import ReactModal from 'react-modal';
import {BrowserRouter as Router} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from 'react-query';

import AuthProvider from 'providers/AuthProvider';
import UIProvider from 'providers/UIProvider';
import './index.css';
import App from 'app';
import mixpanel from 'mixpanel-browser';

if (process.env.NODE_ENV === 'production') {
  const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '';

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    ignore_dnt: true,
  });
}

ReactModal.setAppElement('#root');

const queryClient = new QueryClient();

declare global {
  interface Array<T> {
    findLast(predicate: (value: T, index: number, element: T[]) => unknown): T;
  }
}

function Root() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UIProvider>
            <App />
          </UIProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default Root;
